// Nation-aware terminology and setup field definitions.
export const NATIONS = ["England", "Wales", "Scotland"];

export const NATION_META = {
  England: {
    flag: "🏴󠁧󠁢󠁥󠁮󠁧󠁿",
    badge: "bg-rose-100 text-rose-800 border-rose-300",
    accent: "text-rose-700",
    registration: "Landlord Database (upcoming)",
    lawLabel: "England (Housing Act / Renters' Rights)",
  },
  Wales: {
    flag: "🏴󠁧󠁢󠁷󠁬󠁳󠁿",
    badge: "bg-emerald-100 text-emerald-800 border-emerald-300",
    accent: "text-emerald-700",
    registration: "Rent Smart Wales",
    lawLabel: "Wales (Renting Homes (Wales) Act)",
  },
  Scotland: {
    flag: "🏴󠁧󠁢󠁳󠁣󠁴󠁿",
    badge: "bg-sky-100 text-sky-800 border-sky-300",
    accent: "text-sky-700",
    registration: "Landlord Registration",
    lawLabel: "Scotland (Private Housing (Tenancies) Act)",
  },
};

// setup field schema per nation
export const SETUP_FIELDS = {
  Wales: [
    { key: "number", label: "Rent Smart Wales registration number", type: "text", placeholder: "e.g. 123456/12345/67890" },
    { key: "licence_status", label: "Licence / authorisation status", type: "select", options: ["Licensed", "Applied / pending", "Agent is licensed", "Not yet registered"] },
    { key: "expiry", label: "Licence / registration expiry date", type: "date" },
    { key: "manage_type", label: "How do you manage?", type: "select", options: ["I self-manage", "I use a licensed agent"] },
    { key: "training_renewal", label: "Your training renewal date", type: "date" },
  ],
  Scotland: [
    { key: "number", label: "Local council landlord registration number", type: "text", placeholder: "e.g. 123456/230/12345" },
    { key: "council_area", label: "Council area", type: "text", placeholder: "e.g. City of Edinburgh" },
    { key: "renewal_date", label: "Registration renewal date", type: "date" },
  ],
  England: [
    { key: "landlord_type", label: "Landlord type", type: "select", options: ["Private individual", "Company / Ltd", "Portfolio landlord"] },
    { key: "property_count", label: "Approx. number of properties", type: "number", placeholder: "e.g. 4" },
  ],
};

export const STATUS_STYLE = {
  green: { bg: "bg-emerald-50", border: "border-emerald-300", text: "text-emerald-800", dot: "bg-emerald-600", label: "Compliant" },
  amber: { bg: "bg-amber-50", border: "border-amber-300", text: "text-amber-800", dot: "bg-amber-500", label: "Action soon" },
  red: { bg: "bg-rose-50", border: "border-rose-300", text: "text-rose-800", dot: "bg-rose-600", label: "Action required" },
};
